/**
 * Set up main menu.
 */

// if there's a main menu trigger on this page
const trigger = document.getElementById('site-menu-trigger');
if (trigger) {
	// find additional elements
	const menu = trigger.nextElementSibling;
	const withSub = menu.querySelectorAll('.menu-item-has-children');

	// init accessibility features
	const isMobile = !menu.offsetHeight;
	if (isMobile) {
		menu.setAttribute('aria-hidden', true);
	}

	// trigger expanded/not on menu trigger
	trigger.addEventListener('click', () => {
		const isExpanding = trigger.getAttribute('aria-expanded') !== 'true';
		document.body.classList.toggle('has-active-menu', isExpanding);
		trigger.setAttribute('aria-expanded', isExpanding);
		trigger.setAttribute('aria-label', isExpanding ? 'Close' : 'Menu');
		menu.setAttribute('aria-hidden', !isExpanding);
	});

	// for nav items (li) with sub menus
	withSub.forEach((li) => {
		// cache elements
		const subMenu = li.querySelector('.sub-menu');
		const subMenuId = `${li.getAttribute('id')}-sub`;

		// make li elements tab/clickable in control of subnav
		li.setAttribute('tabindex', '0');
		li.setAttribute('role', 'button');
		li.setAttribute('aria-controls', subMenuId);
		li.setAttribute('aria-expanded', false);

		// identify subnav as being hidden
		subMenu.setAttribute('id', subMenuId);
		subMenu.setAttribute('aria-hidden', true);

		// expand/contract sub nav
		const toggleActive = () => {
			const isExpanding = li.getAttribute('aria-expanded') !== 'true';
			li.setAttribute('aria-expanded', isExpanding);
			subMenu.setAttribute('aria-hidden', !isExpanding);
		};

		// bind the events
		li.addEventListener('focusin', toggleActive);
		li.addEventListener('focusout', toggleActive);

		// ignore # links
		const a = li.firstElementChild;
		if (a.getAttribute('href') === '#') {
			a.setAttribute('tabindex', '-1');
			a.setAttribute('aria-hidden', true);
			li.setAttribute('aria-label', a.textContent);
			a.addEventListener('click', (e) => {
				e.preventDefault();
			});
		}
	});
}
